import { ResponsiveService } from '@frk/eds-components';
import { BaseTableResponsiveComponent } from '@shared/table/base-table-responsive.component';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import {
  FundId,
  FundPerformanceAnnualizedStateConfig,
  FundPerformanceAnnualizedTableData,
  FundPerformanceDates,
} from '@types';

@Component({
  selector: 'ft-fund-performance-annualized-table',
  templateUrl: './fund-performance-annualized-table.component.html',
  styleUrls: ['./fund-performance-annualized-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundPerformanceAnnualizedTableComponent extends BaseTableResponsiveComponent {
  @Input() fundPerformanceData: FundPerformanceAnnualizedTableData[];
  @Input() fundPerformanceConfig: FundPerformanceAnnualizedStateConfig;
  @Input() fundPerformanceDates: FundPerformanceDates;
  @Input() tableLabel: string;
  @Input() tableColumns: string[];
  @Input() showInception: boolean;
  @Input() fundId: FundId;
  @Input() isAllShareClasses: boolean;
  @Input() containerId?: string;
  constructor(
    protected responsiveService: ResponsiveService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(responsiveService, changeDetectorRef);
  }
}
